import React, { Component } from "react";
import { connect } from "react-redux";
import { deactivateOverlayAction } from "../../../services/ui/overlay/actions";

import tracking from "../../../utils/tracking";
import { post } from "../../../utils/api";
import Form from "../../../components/_common/Form";
import TextField from "../../../components/_common/Form/inputs/TextField";
import images from "./images";
import { HEADER_COPY, BODY_COPY, CTA_COPY } from "../../../utils/content-keys";
import validateForm from "../../../components/_common/Form/validate";

import "./booking-form.scss";

class BookingForm extends Component {
  state = {
    step: 1,
    loading: false,
    fields: {
      name: { value: "", showError: false },
      email: { value: "", showError: false },
      phone: { value: "", showError: false, optional: true },
      enquiry: { value: "", showError: false }
    }
  };
  moduleNames = [
    { name: "Private booking - overlay 1", title: "Screen1" },
    { name: "Form field 1 - text field", title: "Form1" },
    { name: "Form field 2 - email field", title: "Form2" },
    { name: "Form field 3 - text field", title: "Form3" },
    { name: "Form field 4 - text field", title: "Form4" },
    { name: "CTA", title: "Cta" },
    { name: "Corporate booking - overlay 2", title: "Screen2" }
  ];

  componentDidMount() {
    if (!this.props.data.fetchedData) {
      this.props.fetchData(
        {
          name: "privateBookingForm",
          modules: this.moduleNames,
          transform: true
        },
        true,
        "PRIVATE BOOKING FORM OVERLAY"
      );
    } else {
      console.log("PrivateBookingForm - data fetched");
    }
  }

  resetForm = () => {
    this.setState(state => {
      state.step = 1;
      Object.keys(state.fields).forEach(key => {
        state.fields[key].value = "";
        state.fields[key].showError = false;
      });

      return state;
    });
  };

  onSubmit = () => {
    const { fields } = this.state;
    const data = {};

    Object.keys(fields).forEach(key => (data[key] = fields[key].value || ""));

    post(data, "private-booking")
      .then(() => {
        tracking.event("customEvent", {
          eventCategory: "Private booking form",
          eventAction: "submit",
          eventLabel: `source: ${this.props.routeProps.location.pathname}`
        });
        tracking.pageView("/contact/thank-you");

        this.setState(state => {
          state.step += 1;
          state.loading = false;
          return state;
        });
      })
      .catch(e => {
        alert(e);
        tracking.event("customEvent", {
          eventCategory: "Private booking form",
          eventAction: "error",
          eventLabel: `${e}, source: ${this.props.routeProps.location.pathname}`
        });
        this.setState({ loading: false });
      });
  };

  filterNumbers = (value, name, key = "value") => {
    this.onFormChange(value.replace(/[^\d\s-]/g, ""), name, key);
  };

  onFormChange = (value, name, key = "value") => {
    this.setState(state => (state.fields[name][key] = value));
  };

  render() {
    const { step, loading } = this.state;
    const { contents } = this.props.data;
    const { id, deactivateOverlayAction } = this.props;

    if (!contents) {
      return null;
    }

    return (
      <Form className="booking-form" finalStep={step === 2}>
        <button
          aria-label="Close Button X"
          className="overlay__close"
          onClick={() => {
            tracking.event("customEvent", {
              eventCategory: "Close Overlay",
              eventAction: "click",
              eventLabel: `${id}, source: ${
                this.props.routeProps.location.pathname
              }`
            });

            deactivateOverlayAction(id);

            if (step > 1) {
              window.setTimeout(this.resetForm, 500);
            }
          }}
        >
          X
        </button>

        {step === 2 && <img src={images.tick} className="booking-form__tick" />}

        <h1 className="form__headline">
          {contents[`Screen${step}`][0][HEADER_COPY].value}
        </h1>
        <p className="form__copy">
          {contents[`Screen${step}`][0][BODY_COPY].value}
        </p>

        {step === 1 && (
          <div className="booking-form__form">
            <TextField
              label={contents.Form1[0][HEADER_COPY].value}
              name="name"
              id="name"
              placeholder={contents.Form1[0][BODY_COPY].value}
              field={this.state.fields.name}
              onChange={this.onFormChange}
            />

            <TextField
              label={contents.Form2[0][HEADER_COPY].value}
              type="email"
              name="email"
              id="email"
              placeholder={contents.Form2[0][BODY_COPY].value}
              field={this.state.fields.email}
              onChange={this.onFormChange}
              errorMessage="Please enter a valid email address"
            />

            <TextField
              label={contents.Form3[0][HEADER_COPY].value}
              type="text"
              name="phone"
              id="phone"
              inputmode="numeric"
              placeholder={contents.Form3[0][BODY_COPY].value}
              field={this.state.fields.phone}
              onChange={this.filterNumbers}
            />

            <label htmlFor="enquiry" className="form__label">
              {contents.Form4[0][HEADER_COPY].value}
            </label>
            <textarea
              id="enquiry"
              name="enquiry"
              className={`form__input form__input--textarea ${
                this.state.fields.enquiry.showError ? "form__input--error" : ""
              }`}
              placeholder={contents.Form4[0][BODY_COPY].value}
              value={this.state.fields.enquiry.value}
              onChange={evt =>
                this.setState(
                  state =>
                    (state.fields.enquiry.value = evt.currentTarget.value)
                )
              }
            />
            {this.state.fields.enquiry.showError && (
              <p className="form__copy form__copy--error">
                *This field is required
              </p>
            )}

            {loading ? (
              <div className="loading" />
            ) : (
              <button
                className="cta cta--lg-font form__cta"
                onClick={() =>
                  this.setState(
                    validateForm(
                      "Private Booking Form",
                      this.props.routeProps,
                      this.onSubmit
                    )
                  )
                }
              >
                {contents.Cta[0][CTA_COPY].value}
              </button>
            )}
          </div>
        )}

        {step === 2 && (
          <button
            class="cta cta--lg-font form__cta"
            onClick={() => {
              this.props.deactivateOverlayAction();
              window.setTimeout(this.resetForm, 500);
            }}
          >
            {contents.Screen2[0][CTA_COPY].value}
          </button>
        )}
      </Form>
    );
  }
}

export default connect(
  state => ({}),
  { deactivateOverlayAction }
)(BookingForm);



// WEBPACK FOOTER //
// ./src/pages/visitus/BookingForm/index.js